import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Users, Plus } from "lucide-react";
import { useOrderList } from "@/context/OrderListContext";

export const PackageCard = ({ pkg }) => {
  const { addPackage } = useOrderList();

  const handleAdd = () => {
    addPackage(pkg);
    toast.success(`${pkg.name} listene eklendi`, {
      description: `${pkg.items.length} ürün sipariş listene aktarıldı.`,
    });
  };

  return (
    <div
      data-testid={`package-card-${pkg.slug}`}
      className="group flex flex-col bg-paper border border-dashed border-bordo/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(122,26,26,0.4)]"
    >
      <Link
        to={`/paket/${pkg.slug}`}
        data-testid={`package-link-${pkg.slug}`}
        className="relative block aspect-[16/10] overflow-hidden"
        aria-label={`${pkg.name} paketini incele`}
      >
        <img
          src={pkg.image}
          alt={pkg.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/10 to-transparent" />
        <span className="absolute right-3 top-3 inline-flex items-center gap-1.5 bg-bordo px-3 py-1 font-mono text-[11px] uppercase tracking-wider text-cream">
          <Users className="h-3.5 w-3.5" /> {pkg.serves}
        </span>
        <h3 className="absolute bottom-3 left-4 right-4 font-serif text-3xl text-cream drop-shadow">{pkg.name}</h3>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <p className="text-sm text-[#8C857D] leading-relaxed">{pkg.description}</p>

        {/* fiş stili içerik */}
        <div className="mt-5 bg-cream px-4 py-4">
          <div className="mb-3 flex items-center justify-between border-b border-dashed border-bordo/30 pb-2">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-charcoal/60">Paket İçeriği</span>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-charcoal/60">Miktar</span>
          </div>
          <ul className="space-y-2">
            {pkg.items.map((it) => (
              <li key={it.slug} className="flex items-center justify-between font-mono text-sm">
                <span className="text-charcoal/85">{it.name}</span>
                <span className="font-bold text-bordo">{it.quantity}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-5 flex flex-col gap-2.5">
          <button
            data-testid={`add-package-${pkg.slug}`}
            onClick={handleAdd}
            className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-sm bg-bordo px-4 py-3 text-sm font-medium uppercase tracking-wide text-cream transition-colors hover:bg-bordo-dark"
          >
            <Plus className="h-4 w-4" /> Sipariş Listeme Ekle
          </button>
          <Link
            to={`/paket/${pkg.slug}`}
            data-testid={`package-detail-link-${pkg.slug}`}
            className="text-center font-mono text-[11px] uppercase tracking-wider text-charcoal/50 transition-colors hover:text-bordo"
          >
            Paketi İncele →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
